import React from 'react'
import { Checkbox } from '@progress/kendo-react-inputs';


export function UiCheckBox(props) {

    const {
        validationMessage,
        label,
        visited,
        handleChange,
        placeholder,
        value,
        checked,
        name,
        ...others
      } = props;
    

    return (
        <>
            <Checkbox name={name} onChange={handleChange} value={value} label={label} />
            {visited && validationMessage && <Error>{validationMessage}</Error>}
            
        </>
    )
}
